export const SET_DOCUMENTS = "SET_DOCUMENTS";
export const SET_DOCUMENT_READ = "SET_DOCUMENT_READ";
export const SET_UNREAD_DOCUMENTS_PRESENT = "SET_UNREAD_DOCUMENTS_PRESENT";

export function setDocuments(response) {
    return {
        type: SET_DOCUMENTS,
        documents: (response._embedded && response._embedded.correspondenceResourceList) || [],
        nextPage: (response._links && response._links.next && response._links.next.href) || "",
        totalDocuments: (response.page && response.page.totalElements) || 0
    };
}

export function setDocumentRead(documentRead) {
    return {
        type: SET_DOCUMENT_READ,
        documentRead
    };
}

export function setUnreadDocumentsPresent(present) {
    return {
        type: SET_UNREAD_DOCUMENTS_PRESENT,
        present
    };
}
